// extracted by mini-css-extract-plugin
export default {"TwoDimsFeature":"wh_a bht_b bht_we"};